module.exports = __webpack_public_path__ + "static/media/undo-alt.5ee04a94.svg";